import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/login'
import projectMain from '../views/projectDetail/projectMain.vue'
import projectArea from '../views/projectDetail/child/projectArea.vue'
import projectAreaDetail from '../views/projectDetail/child/projectAreaDetail.vue'
import areaList from '../views/projectDetail/child/areaList.vue'
import devData from '../views/projectDetail/child/devData.vue'
// import projectAim from '../views/projectDetail/child/projectAim.vue'
import authManage from '../views/projectDetail/child/authManage.vue'
import devLog from '../views/projectDetail/child/devLog.vue'
import airDev from '../views/projectDetail/child/airDev.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/home.vue')
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/projectMain:id',
    redirect: '/projectDetail:id',
    component: projectMain,
    children: [
      {
        path: '/projectDetail:id',
        component: projectArea
      },
      {
        path: '/projectAreaDetail:id',
        component: projectAreaDetail
      },
      {
        path: '/areaList:id',
        component: areaList
      },
      {
        path: '/devData:id',
        component: devData
      },
      /*
      {
        path: '/aimProject:id',
        component: projectAim
      },
      */
      {
        path: '/authManage',
        component: authManage
      },
      {
        path: '/devLog',
        component: devLog
      },
      {
        path: '/airDev',
        component: airDev
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'act'
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login') {
    if (window.localStorage.getItem('token')) {
      next()
    } else {
      router.push('/login')
    }
  } else {
    if (window.localStorage.getItem('token')) {
      router.push('/home')
    } else {
      next()
    }
  }
})
export default router
